import { useRef, useState } from "React";

//interfaces
import { IActivityFeedMenuProps } from "@/interfaces/activityFeed";

//components
import {MenuButton, CommentButton, LikeButton, ThriveIcon, IconLibrary} from "thrive-components";
import { useClickAwayClose } from "@/components/hooks/utility/useClickAwayClose";

import "../../../../css/activityFeed/elements/activity-menu.scss";



const ActivityMenu = ({ onLikeClick, isLiked = false, isReply=false,  onReplyClick, getWebLink, onDeleteClick, onDownloadReportClick, onArchiveContentClick, onApproveContentClick, onDownloadCSVClick, userPageLink }: IActivityFeedMenuProps) => {
    if (!onLikeClick && !onReplyClick && !getWebLink && !onDeleteClick && !onDownloadReportClick && !onArchiveContentClick && !onApproveContentClick && !onDownloadCSVClick && !userPageLink) {
        return <></>;
    }

    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<any>(null);
    const toggleMenu = () => setIsOpen(!isOpen);
    useClickAwayClose(isOpen, menuRef, () => setIsOpen(false));

    const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
        if (menuRef.current && !menuRef.current.contains(event.relatedTarget as Node)) {
            setIsOpen(false)
        }
    };

    const handleItemClick = (onClickFunction?: () => void) => {
        if (onClickFunction) onClickFunction();
        setIsOpen(false);
    };
    
    
    return (
        <div className="user-activity-menu-wrapper" ref={menuRef} onBlur={handleBlur} onClick={(e) => e.stopPropagation()}>
            <MenuButton onButtonClick={toggleMenu} aria-expanded={isOpen} ariaLabel={`${isOpen ? "Close Menu" : "Open Menu"}`}/>
            
            {isOpen && (
                <ul className="user-activity-menu">
                    {onLikeClick && <li><LikeButton ariaLabel={isLiked ? "Unlike the content item" : "Like content item"} onButtonClick={()=>handleItemClick(onLikeClick)} includeText={true} isActive={isLiked} className={`${isLiked && "liked"} `} /></li>}
                    
                    {onReplyClick && <li><CommentButton ariaLabel={"Add a new comment to this content"} onButtonClick={() => handleItemClick(onReplyClick)} includeText={true} isActive={false} isReply={isReply} /></li>}
                    
                    {getWebLink && <li><a aria-label="Open on Web" href={getWebLink()} target="__blank" role="menuitem" className="blue-item"><ThriveIcon iconName={IconLibrary.EXTERNAL_LINK} sizeInPx="12" color="#343d4c" className="external-link" /> Open on Web</a></li>}
                    
                    {userPageLink && <li><a aria-label="Open edit user page" href={userPageLink} role="menuitem" className="blue-item"><ThriveIcon iconName={IconLibrary.USER_COG} sizeInPx="12" color="#343d4c" className="download"/>Go to user</a></li>}
                    
                    {onDeleteClick && <li><button aria-label="Delete Comment" onClick={() => handleItemClick(onDeleteClick)} role="menuitem" className="red-item"><ThriveIcon iconName={IconLibrary.ARCHIVE} sizeInPx="12" color="#d12a36" className="delete"/> Delete Comment</button></li>}
                    
                    {onDownloadReportClick && <li><button aria-label="Download Report" onClick={() => handleItemClick(onDownloadReportClick)} role="menuitem" className="blue-item"><ThriveIcon iconName={IconLibrary.DOWNLOAD} sizeInPx="12" color="#343d4c" className="download"/> Download Report</button></li>}

                    {onApproveContentClick && <li><button aria-label="Approve Content" onClick={() => handleItemClick(onApproveContentClick)} role="menuitem" className="blue-item"><ThriveIcon iconName={IconLibrary.CHECK_DOUBLE} sizeInPx="12" color="#343d4c" className="external-link"/>Approve</button></li>}

                    {onArchiveContentClick && <li><button aria-label="Archive Content" onClick={() => handleItemClick(onArchiveContentClick)} role="menuitem" className="red-item"><ThriveIcon iconName={IconLibrary.ARCHIVE} sizeInPx="12" color="#d12a36" className="archive"/> Archive Content</button></li>}

                    {onDownloadCSVClick && <li><button aria-label="Download CSV" onClick={() => handleItemClick(onDownloadCSVClick)} role="menuitem" className="blue-item"><ThriveIcon iconName={IconLibrary.DOWNLOAD} sizeInPx="12" color="#343d4c" className="download"/> Download CSV</button></li>}
                </ul>
            )}
        </div>
    );
};

export default ActivityMenu